import { useMemo } from 'react';
import { getDefaultLang } from '../../../../../helpers/lang';
import { useLang } from '../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { useBranchesStore } from '../../../../../store/use-branch-store';
import { useEmployeesStore } from '../../../../../store/use-employee-store';
import { useTagStaffStore } from '../../../../../store/use-tag-staff-store';
import { useModalParams } from '../../../../../hooks/use-modal-params';
import { concatPath, buildParams } from '../../../../../helpers/path';
import { RootPath, ManagerPath, StaffPath } from '../../../../../routes/manager/manager-enums';
import { useRouter } from '../../../../../hooks/use-router';

export const useEmployeesUtils = () => {
  const { staff, isLoadingFetch, restoreEmployee, pagination } = useEmployeesStore();
  const { place } = useBranchesStore();
  const { tags: tag } = useTagStaffStore();
  const { currentLang, getLocale, t } = useLang();
  const { addQueryParams, getQueryParams } = useQueryParams();
  const params = getQueryParams();

  const branches = useMemo(
    () =>
      place?.map((item) => ({
        id: String(item.id),
        value: item.name[currentLang] || item.name[getDefaultLang()] || '',
      })) || [],
    [currentLang, place],
  );

  const withFullName = useMemo(() => {
    return staff?.map((item) => ({
      ...item,
      full_name: `${getLocale(item.name)} ${getLocale(item.surname)}`,
    }));
  }, [staff, getLocale]);

  const createEmployeeModal = useModalParams('createEmployee');
  const deleteEmployeeModal = useModalParams('deleteEmployee');
  const unlinkEmployeeModal = useModalParams('unlinkEmployee');
  const jobTitlesModal = useModalParams('jobTitlesModal');
  const qrEmployeeModal = useModalParams('qrEmployee');

  const { navigate } = useRouter();

  const navigateToProfile = (id: number) => {
    navigate(
      concatPath([RootPath.Manager, ManagerPath.Staff, StaffPath.EmployeeProfile]) +
        buildParams({ employeeId: id }),
    );
  };

  return {
    staff: withFullName,
    isLoadingFetch,
    getLocale,
    branches,
    t,
    tag,
    place,

    addQueryParams,
    restoreEmployee,
    params,
    pagination,
    navigate,

    createEmployeeModal,
    deleteEmployeeModal,
    unlinkEmployeeModal,
    jobTitlesModal,
    qrEmployeeModal,

    navigateToProfile,
  };
};
